export default __webpack_public_path__ + "static/media/exterior3.505df6a9.webp";